import ViewProductCatalog from "../catalog/viewProductCatalog";
import YouLikeIt from "../catalog/youLikeIt";
import Footer from "../standartComponent/footer/footer";
import Header from "../standartComponent/header/header";
import Description from "./description";
import Hero from "./hero";
import HeroPage from "./heroPage";
import css from "./product.module.css";
import ProductPageTitle from "./productPageTitle";
import Respons from "./respons";
import ResponsTextArea from "./responsTextArea";
import VideoBlock from "./videoBlock";
import WhyNeedRead from "./whyNeedRead";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import transliterate from "../../function/transliterate";
import {
  getAuth,
  signInWithPhoneNumber,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { useEffect } from "react";
import { auth, db } from "../../firebase";
import {
  getProductSlug,
  getProductHref,
  isProductMatchBySlug,
  normalizeProductSlug,
} from "../../function/productLink";
import {
  doc,
  setDoc,
  addDoc,
  collection,
  serverTimestamp,
  getDocs,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";

import keyWord from "../../keyWord";
import ViewProductCros from "../catalog/viewProductCros";
export default function Product({
  products,
  setAddressChanged,
  addressChanged,
  setLogin,
  windowDimensions,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [reloadP, setReloadP] = useState(true);
  const [isOrdered, setIsOrdered] = useState(false);
  const [hasReviewed, setHasReviewed] = useState(false);
  const [user, setUser] = useState("");
  const [rerenderAfter, setRerenderAfter] = useState(false);
  const [oneProd, setOneProd] = useState();
  const [haveProd, setHaveProd] = useState(false);
  const [rewievList, setRewievList] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  let params = useParams();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        // Користувач увійшов в систему
        setUser(currentUser);
      } else {
        // Користувач вийшов з системи

        setUser(null);
      }
    });

    return () => {
      // Відписка від слухача після розмонтовування компоненти
      unsubscribe();
    };
  }, []);

  // useEffect(() => {
  //   let isMounted = true;

  //   for (let i = 0; i < products.length; i++) {
  //     if (transliterate(products[i].bookName) === params.id) {
  //       setOneProd(products[i]);

  //       setHaveProd(true);
  //     }
  //   }
  // }, [products, addressChanged, params.id]);
  useEffect(() => {
    if (!products?.length) {
      setOneProd(null);
      setHaveProd(false);
      return;
    }

    const foundProduct = products.find((product) =>
      isProductMatchBySlug(product, params.id),
    );

    if (foundProduct) {
      setOneProd(foundProduct);
      setHaveProd(true);
    } else {
      setOneProd(null);
      setHaveProd(false);
    }
  }, [products, addressChanged, params.id]);
  // useEffect(() => {
  //   if (!oneProd) return;

  //   const currentSlug = normalizeProductSlug(params.id);
  //   const canonicalSlug = getProductSlug(oneProd);

  //   if (currentSlug !== canonicalSlug) {
  //     navigate(getProductHref(oneProd), { replace: true });
  //   }
  // }, [oneProd, params.id, navigate]);
  useEffect(() => {
    if (!oneProd) return;

    // якщо це ще старий товар — нічого не редіректимо
    if (!isProductMatchBySlug(oneProd, params.id)) return;

    const currentSlug = normalizeProductSlug(params.id);
    const canonicalSlug = getProductSlug(oneProd);

    if (currentSlug !== canonicalSlug) {
      navigate(getProductHref(oneProd), { replace: true });
    }
  }, [oneProd, params.id, navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {
    if (!haveProd || !oneProd) return;

    document.title = oneProd.ceoTitle;

    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaDescription) {
      metaDescription.setAttribute("content", oneProd.coeDescription);
    } else {
      const newMetaDescription = document.createElement("meta");
      newMetaDescription.setAttribute("name", "description");
      newMetaDescription.setAttribute("content", oneProd.coeDescription);
      document.head.appendChild(newMetaDescription);
    }
  }, [oneProd, haveProd]);
  useEffect(() => {
    if (!haveProd || !oneProd?.uid) {
      setRewievList([]);
      return;
    }

    const reviewsQuery = query(
      collection(db, "reviews"),
      where("productId", "==", oneProd.uid),
    );

    const unsubscribe = onSnapshot(
      reviewsQuery,
      (snapshot) => {
        const reviews = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((review) => review.visible !== false)
          .sort((a, b) => {
            const getTime = (value) => {
              if (!value) return 0;
              if (value.toMillis) return value.toMillis();
              if (value.seconds) return value.seconds * 1000;
              return 0;
            };

            return getTime(a.createdAt) - getTime(b.createdAt);
          });

        setRewievList(reviews);
      },
      (error) => {
        console.error("Помилка live-завантаження відгуків:", error);
      },
    );

    return () => unsubscribe();
  }, [oneProd?.uid, haveProd]);
  useEffect(() => {
    if (oneProd) {
      const bookName = oneProd.bookName;
      const author = oneProd.textAutor;
      // Генеруємо динамічний title
      const dynamicTitle = `Книга ${bookName} Видавництво Час Майстрів`;

      // Генеруємо динамічний description
      const dynamicDescription = `Книга ${bookName} від автора ${author}. Видавництво "Час Майстрів". Розвивайте уяву, творчість і любов до читання. Замовляйте онлайн!`;
      // Використовуємо keyWord для генерації мета-тегів
      keyWord(dynamicTitle, dynamicDescription);

      // Встановлюємо мета title
      document.title = dynamicTitle;

      // Встановлюємо мета description
      const metaDescription = document.querySelector(
        'meta[name="description"]',
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", dynamicDescription);
      } else {
        const newMetaDescription = document.createElement("meta");
        newMetaDescription.setAttribute("name", "description");
        newMetaDescription.setAttribute("content", dynamicDescription);
        document.head.appendChild(newMetaDescription);
      }
    }
  }, [oneProd]);
  // функціонал для корегування відгуків

  useEffect(() => {
    const checkOrder = async () => {
      if (user && oneProd) {
        try {
          const ordersCol = collection(db, "orders");
          const q = query(ordersCol, where("user", "==", user.uid));
          const querySnapshot = await getDocs(q);

          querySnapshot.forEach((doc) => {
            const order = { id: doc.id, ...doc.data() };
            const choice = JSON.parse(order.choice);

            const foundProduct = choice.find(
              (tovar) => tovar.uid === oneProd.uid,
            );
            if (foundProduct) {
              setIsOrdered(true);
            }
          });
        } catch (error) {
          console.error("Error checking order:", error);
        }
      }
    };
    // Перевіряємо, чи користувач вже робив відгук для цього товару
    const checkReview = async () => {
      if (user && oneProd) {
        try {
          const reviewsCol = collection(db, "reviews");
          const q = query(
            reviewsCol,
            where("productId", "==", oneProd.uid),
            where("userUid", "==", user.uid),
          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            setHasReviewed(true);
          }
        } catch (error) {
          console.error("Error checking review:", error);
        }
      }
    };

    checkOrder();
    checkReview();
  }, [oneProd, user, rerenderAfter]);

  const enterUser = () => {
    setLogin(true);
  };
  useEffect(() => {
    const checkActionsForProduct = async () => {
      if (!oneProd) return;

      // 1. Підтягуємо всі акції
      const snapshotActions = await getDocs(collection(db, "actions"));
      const actions = snapshotActions.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const now = new Date();

      // 2. Знаходимо чи є акція для поточного товару
      const matchedAction = actions.find((action) => {
        const start = action.startDate ? new Date(action.startDate) : null;
        const end = new Date(action.endDate);

        const matchProduct = action.appliesTo.products?.includes(oneProd.id);

        const productSeries = Array.isArray(oneProd.seria)
          ? oneProd.seria
          : typeof oneProd.seria === "string" && oneProd.seria !== ""
            ? [oneProd.seria]
            : [];

        const matchSeries = productSeries.some((ser) =>
          action.appliesTo.series?.includes(ser),
        );

        const productAuthors = Array.isArray(oneProd.textAutor)
          ? oneProd.textAutor.map((a) => a.split(" ")[0])
          : typeof oneProd.textAutor === "string" && oneProd.textAutor !== ""
            ? [oneProd.textAutor.split(" ")[0]]
            : [];

        const actionAuthors = Array.isArray(action.appliesTo.authors)
          ? action.appliesTo.authors.map((a) => a.split(" ")[0])
          : [];

        const matchAuthor = productAuthors.some((a) =>
          actionAuthors.includes(a),
        );

        return (
          (matchProduct || matchSeries || matchAuthor) &&
          (!start || now >= start) &&
          now <= end
        );
      });

      if (matchedAction) {
        // 3. Якщо знайшли акцію — додаємо actionDiscountPercent
        const discount = matchedAction.discountPercent;
        const newPrice = Math.round(
          oneProd.price - (oneProd.price * discount) / 100,
        );

        // Додаємо у стан
        setOneProd({
          ...oneProd,
          actionDiscountPercent: discount,
          actionPrice: newPrice,
        });
      }
    };

    checkActionsForProduct();
  }, [oneProd]);
  useEffect(() => {
    const checkSalesForProduct = async () => {
      if (!oneProd) return;

      try {
        const snapshotSales = await getDocs(collection(db, "sales"));
        const sales = snapshotSales.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const now = new Date();

        // series може називатись seria | series
        const productSeries = Array.isArray(oneProd.seria)
          ? oneProd.seria
          : typeof oneProd.seria === "string" && oneProd.seria !== ""
            ? [oneProd.seria]
            : Array.isArray(oneProd.series)
              ? oneProd.series
              : typeof oneProd.series === "string" && oneProd.series !== ""
                ? [oneProd.series]
                : [];

        // автор(и): беремо лише прізвище (перше слово), як і в інших місцях проєкту
        const productAuthors = Array.isArray(oneProd.textAutor)
          ? oneProd.textAutor.map((a) => a.split(" ")[0].trim())
          : typeof oneProd.textAutor === "string" && oneProd.textAutor !== ""
            ? [oneProd.textAutor.split(" ")[0].trim()]
            : [];

        // знаходимо перший підходящий розпродаж
        const matchedSale = sales.find((sale) => {
          const start = sale.startDate ? new Date(sale.startDate) : null;
          const end = sale.endDate ? new Date(sale.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const applies = sale.appliesTo || {};

          const matchProduct =
            Array.isArray(applies.products) &&
            applies.products.some(
              (pid) => pid === oneProd.uid || pid === oneProd.id,
            );

          const matchSeries =
            Array.isArray(applies.series) &&
            productSeries.some((ser) => applies.series.includes(ser));

          const saleAuthors = Array.isArray(applies.authors)
            ? applies.authors.map((a) => a.split(" ")[0].trim())
            : [];
          const matchAuthor = productAuthors.some((a) =>
            saleAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });

        if (matchedSale) {
          const discount = Number(matchedSale.discountPercent) || 0;
          const newPrice = Math.round(
            Number(oneProd.price) - (Number(oneProd.price) * discount) / 100,
          );

          // не оновлюємо стан, якщо значення не змінились
          setOneProd((prev) => {
            const samePct = prev.saleDiscountPercent === discount;
            const samePrice = prev.salePrice === newPrice;
            if (samePct && samePrice) return prev;
            return {
              ...prev,
              saleDiscountPercent: discount,
              salePrice: newPrice,
            };
          });
        }
      } catch (e) {
        console.error("Помилка при перевірці розпродажу:", e);
      }
    };

    checkSalesForProduct();
  }, [oneProd]);

  return (
    <>
      {haveProd && oneProd && (
        <>
          <ProductPageTitle
            key={oneProd.uid || oneProd.id || params.id}
            oneProd={oneProd}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          {/* <Description oneProd={oneProd} /> */}
          <WhyNeedRead oneProd={oneProd} />
          <VideoBlock windowDimensions={windowDimensions} oneProd={oneProd} />

          <Hero oneProd={oneProd} />
          <HeroPage oneProd={oneProd} />
          {rewievList.length > 0 && (
            <>
              <Respons rewievList={rewievList} reloadP={reloadP} />
            </>
          )}
          {user && (
            <>
              {isOrdered && !hasReviewed ? (
                <ResponsTextArea
                  rerenderAfter={rerenderAfter}
                  setRerenderAfter={setRerenderAfter}
                  user={user}
                  oneProd={oneProd}
                  reloadP={reloadP}
                  setReloadP={setReloadP}
                />
              ) : (
                <p className={css.canNotAddDesc}>
                  Ви не можете додати відгук до цього товару, оскільки ви вже
                  додали відгук до нього або ще не придбали товар.
                </p>
              )}
            </>
          )}
          {!user && (
            <div className={css.buttonReg}>
              Для того щоб додати відгук{" "}
              <span className={css.buttonRegSpan} onClick={enterUser}>
                Зареєструйтесь
              </span>{" "}
            </div>
          )}
          <ViewProductCros
            currentProductId={oneProd.uid} // ось!
            setAddressChanged={setAddressChanged}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <ViewProductCatalog
            products={products}
            setAddressChanged={setAddressChanged}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <Footer />
        </>
      )}
    </>
  );
}
